import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CostGuide from "../pages/cost-guide/page";
import FreeQuote from "../pages/free-quote/page";
import ServiceAreas from "../pages/service-areas/page";
import CityPage from "../pages/city/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/cost-guide",
    element: <CostGuide />,
  },
  {
    path: "/free-quote",
    element: <FreeQuote />,
  },
  {
    path: "/service-areas",
    element: <ServiceAreas />,
  },
  {
    path: "/tree-service/:citySlug",
    element: <CityPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
